import { Suspense, type ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { Footer } from './Footer';
import { MobileNav } from './MobileNav';
import { BookingAlarm } from '@/components/booking/BookingAlarm';
import { ToastViewport } from '@/components/ui/Toast';
import { Skeleton } from '@/components/ui/Skeleton';

function PageFallback() {
  return (
    <div className="space-y-4 p-4 lg:p-8">
      <Skeleton className="h-10 w-64" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-32" />
        ))}
      </div>
      <Skeleton className="h-80" />
    </div>
  );
}

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen bg-base">
      <Sidebar />
      <MobileNav />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1">
          <Suspense fallback={<PageFallback />}>{children}</Suspense>
        </main>
        <Footer />
      </div>
      <ToastViewport />
      <BookingAlarm />
    </div>
  );
}
